import React from "react";
import "./ProjectDetailsBanner.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";

import bgImage from "../../../../assets/images/services/hero.png";

const ProjectDetailsBanner = ({ project }) => {
  return (
    <section className="project-banner">
      
      <img src={bgImage} alt="bg" className="project-banner__bg" />

      <div className="project-banner__overlay" />

      <div className="project-banner__content">
        
        <CmsText
          content={project?.tag ?? "Case Study"}
          as="span"
          className="project-banner__tag"
        />

        <CmsText
          content={project?.title ?? "Project name or short project outcome"}
          as="h1"
          className="project-banner__title"
        />

        <RichTextContent
          content={project?.desc ?? ""}
          className="project-banner__desc"
        />

        <div className="project-banner__services">
          {(project?.services ?? ["Service tag", "Service tag", "Service tag"]).map((s) => (
            <CmsText key={s} content={s} as="span" />
          ))}
        </div>

      </div>
    </section>
  );
};

export default ProjectDetailsBanner;